const Bio5Hats = [
	18971, 18972, 18973, 18974, 18975, 18976, 18977, 18978, 18979, 18980, 18981,
	18982, 18983, 18984,
]
const IllusionArmors = [15376, 15377]
const IllusionWings = [20933, 20934]
const IllusionLegs = [22196, 22197]
const IllusionLeftAccessories = [32207, 32209]
const IllusionRightAccessories = [32208, 32210]

const AutomaticArmors = [450127, 450128]
const AutomaticWings = [480020, 480021]
const AutomaticLegs = [470022, 470023]
const AutomaticLeftAccessories = [490025, 490027]
const AutomaticRightAccessories = [490024, 490026]

const IllusionShield = [460004, 460014, 460099]

const KingScmidtInsigna = [32228, 32229, 32230, 32231, 32232, 32233]
const KingScmidtSuit = [15388]
const KingScmidtManteau = [15389]

const TemporalBoots = [
	22000, 22001, 22002, 22003, 22004, 22005, 22006, 22007, 22008, 22009, 22010,
	22011, 22107, 22108, 22109, 22110, 22111, 22112, 22113, 22114, 22115, 22116,
	22117, 22118,
]

export function isEnchantable(itemID) {
	if (Bio5Hats.includes(itemID)) return true
	if (IllusionArmors.includes(itemID)) return true
	if (IllusionWings.includes(itemID)) return true
	if (IllusionLegs.includes(itemID)) return true
	if (IllusionLeftAccessories.includes(itemID)) return true
	if (IllusionRightAccessories.includes(itemID)) return true
	if (AutomaticArmors.includes(itemID)) return true
	if (AutomaticWings.includes(itemID)) return true
	if (AutomaticLegs.includes(itemID)) return true
	if (AutomaticLeftAccessories.includes(itemID)) return true
	if (AutomaticRightAccessories.includes(itemID)) return true
	if (IllusionShield.includes(itemID)) return true
	if (KingScmidtInsigna.includes(itemID)) return true
	if (KingScmidtSuit.includes(itemID)) return true
	if (KingScmidtManteau.includes(itemID)) return true
	if (TemporalBoots.includes(itemID)) return true

	return false
}

export function isEnchantSlot(itemID, Slot) {
	if (Slot === 3 || Slot === 2 || Slot === 1) {
		return isEnchantable(itemID)
	}
	return false
}

export function getEnchant(itemID, slot) {
	if (Bio5Hats.includes(itemID)) {
		if (slot === 2 || slot === 3)
			return [
				// Strength1
				4700, 4701, 4702, 4703, 4704,
				// Inteligence1
				4710, 4711, 4712, 4713, 4714,
				// Dexterity1
				4720, 4721, 4722, 4723, 4724,
				// Agility1
				4730, 4731, 4732, 4733, 4734,
				// Vitality1
				4740, 4741, 4742, 4743, 4744,
				// Luck1
				4750, 4751, 4752, 4753, 4754,
			]
		if (slot === 1)
			return [
				// Strength4
				4703, 4704,
				// Inteligence4
				4713, 4714,
				// Dexterity4
				4723, 4724,
				// Agility4
				4733, 4734,
				// Vitality4
				4743, 4744,
				// Luck4
				4753, 4754,
				// Ambition1Lv (Mettle)
				29061, 29062, 29063, 29064, 29065, 29066, 29067, 29068, 29069,
				29070,
				// Tab1Lv (Magic Essence)
				29071, 29072, 29073, 29074, 29075, 29076, 29077, 29078, 29079,
				29080,
				// Expect1Lv (Acute)
				29081, 29082, 29083, 29084, 29085, 29086, 29087, 29088, 29089,
				29090,
				// ArchLine1Lv (Master Archer)
				29091, 29092, 29093, 29094, 29095, 29096, 29097, 29098, 29099,
				29100,
				// Steel1Lv (Adamantine)
				29101, 29102, 29103, 29104, 29105, 29106, 29107, 29108, 29109,
				29110,
				// Mercy1Lv (Affection)
				29111, 29112, 29113, 29114, 29115, 29116, 29117, 29118, 29119,
				29120,
			]
	}
	//Illusion gears
	if (IllusionArmors.includes(itemID))
		return [29527, 29528, 29534, 29535, 29536, 29540]
	if (IllusionWings.includes(itemID))
		return [29527, 29528, 29537, 29538, 29539, 29542]
	if (IllusionLegs.includes(itemID)) {
		if (slot === 3)
			return [
				29527, 29528, 29531, 29530, 29533, 29541, 29547, 29548, 29549,
				29550, 29551, 29552,
			]
		if (slot === 1 || slot === 2)
			return [29527, 29528, 29531, 29530, 29533, 29541]
	}
	if (IllusionLeftAccessories.includes(itemID))
		return [
			4742, 4752, 4712, 4722, 4826, 4881, 4866, 4836, 29532, 29544, 29546,
		]
	if (IllusionRightAccessories.includes(itemID))
		return [
			4742, 4752, 4702, 4732, 4826, 4881, 4866, 4836, 29529,
			//25696, 25698,
		]
	//Automatic gears
	if (AutomaticArmors.includes(itemID))
		return [
			310082, 310083, 310099, 310100, 310101, 310105, 310106, 310107,
			310108, 310109, 310110, 310117, 310178, 310127, 310128, 310129,
			310130, 310131, 310132, 310133, 310134, 310135, 310136, 310137,
			310138, 310139, 310140, 310141, 310142, 310143, 310144, 310145,
			310146, 310147, 310148, 310149, 310150, 310151, 310152, 310153,
			310154, 310155, 310156, 310157, 310158, 310159, 310160, 310161,
			310162, 310163, 310164, 310165, 310166, 310167, 310168, 310169,
			310170, 310171, 310172, 310173, 310174, 310175, 310176, 310177,
		]
	if (AutomaticWings.includes(itemID))
		return [310082, 310083, 310102, 310103, 310104, 310112, 310119, 310179]
	if (AutomaticLegs.includes(itemID)) {
		if (slot === 3)
			return [
				310082, 310083, 310096, 310097, 310098, 310111, 310118, 310121,
				310122, 310123, 310124, 310125, 310126,
			]
		if (slot === 1 || slot === 2)
			return [310082, 310083, 310096, 310097, 310098, 310111, 310118]
	}
	if (AutomaticLeftAccessories.includes(itemID))
		return [
			310084, 310085, 310088, 310089, 310091, 310092, 310093, 310094,
			310095, 310114, 310116, 310120,
		]
	if (AutomaticRightAccessories.includes(itemID))
		return [
			310084, 310085, 310086, 310087, 310090, 310092, 310093, 310094,
			310095, 310113, 310115, 310120,
		]
	if (IllusionShield.includes(itemID))
		return [
			29552, 29551, 29550, 29549, 29548, 29547, 29546, 29545, 29544,
			29543, 29540, 29539, 29538, 29537, 29536, 29535, 29534, 29533,
			29532, 29531, 29530, 29529, 29528, 29527,
		]
	if (KingScmidtInsigna.includes(itemID)) {
		if (slot === 3)
			return [
				4702, 4703, 4704, 4732, 4733, 4734, 4742, 4743, 4744, 4712,
				4713, 4714, 4722, 4723, 4724, 4752, 4753, 4754,
			]
		if (slot === 2)
			return [4821, 4822, 4812, 4826, 4843, 4844, 4835, 4836, 4864, 4865]
		if (slot === 1) return [29587, 29588, 29589, 29590, 29591, 29592]
	}
	if (KingScmidtSuit.includes(itemID)) {
		if (slot === 1) return [4702, 4712, 4722, 4732, 4742, 4752]
		if (slot === 2 || slot === 3)
			return [
				4702, 4703, 4704, 4712, 4713, 4714, 4722, 4723, 4724, 4732,
				4733, 4734, 4742, 4743, 4744, 4752, 4753, 4754,
			]
	}
	if (KingScmidtManteau.includes(itemID)) {
		if (slot === 3 || slot === 2 || slot === 1)
			return [
				4808, 4820, 4821, 4813, 4812, 4826, 4817, 4816, 4843, 4834,
				4835, 4836, 4863, 4864, 4865,
			]
	}
	if (TemporalBoots.includes(itemID)) {
		if (slot === 3)
			return [
				4752, 4753, 4754, 4755, 4869, 4872, 4873, 4881, 4741, 4742,
				4861, 4862, 4814, 4813, 4812, 4826, 4832, 4833, 4834, 4835,
				4808, 4820, 4821, 4822,
			]
		if (slot === 2) return [4875, 4879, 4880, 4878, 4876, 4877]
	}
	return -1
}
